<div class="panel-container">
  <!-- Search Bar -->
  <div class="search-container">
    <input
      type="text"
      class="search-input"
      placeholder="Buscar"
      [(ngModel)]="searchText"
      (input)="onSearch()"
    />
    <button class="search-button" (click)="onSearch()">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>

  <!-- Cards Container -->
  <div class="cards-container">
    <div
      class="card"
      *ngFor="let card of displayedCards"
      (click)="openModal(card)"
    >
      <!-- Card Header -->
      <div class="card-header">
        <sit-icon 
          [icon]="Icon.trash_icon" 
          [sizeClass]="'icon-size-32'"
          matTooltip="Basura"
        ></sit-icon>
        <span class="card-title">{{ card.binAddress }}</span>
      </div>

      <div class="card-divider"></div>

      <!-- Card Body -->
      <div class="card-body-grid">
        <!-- Porcentaje de llenado -->
        <div class="card-info-item">
          <sit-icon 
            [icon]="Icon.ruler_icon" 
            [sizeClass]="'icon-size-28'"
            matTooltip="Capacidad"
          ></sit-icon>
          <span class="card-info-value" [class.text-danger]="getFillingPercentage(card) >= 70" [class.text-warning]="getFillingPercentage(card) >= 40 && getFillingPercentage(card) < 70" [class.text-success]="getFillingPercentage(card) < 40">{{ getFillingPercentage(card) }}%</span>
        </div>
        
        <!-- ID del contenedor -->
        <div class="card-info-item">
          <sit-icon 
            [icon]="Icon.identification_card" 
            [sizeClass]="'icon-size-28'"
            matTooltip="ID Contenedor"
          ></sit-icon>
          <span class="card-info-value">{{ card.licensePlate || card.binId }}</span>
        </div>
        
        <!-- Estado -->
        <div class="card-info-item">
          <sit-icon 
            [icon]="Icon.check_circle_green" 
            [sizeClass]="'icon-size-28'"
            matTooltip="Estado"
          ></sit-icon>
          <span class="card-info-value">Conectado</span>
        </div>
        
        <!-- Categoría -->
        <div class="card-info-item">
          <sit-icon 
            [icon]="Icon.package_icon" 
            [sizeClass]="'icon-size-28'"
            matTooltip="Categoría"
          ></sit-icon>
          <span class="card-info-value">{{ card.typeWaste }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-container">
    <div class="pagination-info">
      <select
        class="page-size-select"
        [(ngModel)]="pageSize"
        (change)="changePageSize(pageSize)"
      >
        <option [value]="10">10</option>
        <option [value]="20">20</option>
        <option [value]="50">50</option>
      </select>
      <span class="pagination-text"
        >{{ displayedCards.length }} de {{ totalRecords }} resultados</span
      >
    </div>
    <div class="pagination-controls">
      <button
        class="pagination-button"
        (click)="goToFirstPage()"
        [disabled]="currentPage === 0"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M18.41 16.59L13.82 12L18.41 7.41L17 6L11 12L17 18L18.41 16.59ZM6 6H8V18H6V6Z"
          />
        </svg>
      </button>
      <button
        class="pagination-button"
        (click)="previousPage()"
        [disabled]="currentPage === 0"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z"
          />
        </svg>
      </button>
      <button
        class="pagination-button"
        (click)="nextPage()"
        [disabled]="(currentPage + 1) * pageSize >= totalRecords"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12L10 6Z" />
        </svg>
      </button>
      <button
        class="pagination-button"
        (click)="goToLastPage()"
        [disabled]="(currentPage + 1) * pageSize >= totalRecords"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M5.59 7.41L10.18 12L5.59 16.59L7 18L13 12L7 6L5.59 7.41ZM16 6H18V18H16V6Z"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
